import { config } from '@/utils/config';

export const mediaMixin = {
  data() {
    return {
      mediaUrl: config.mediaURL?.endsWith('/')
        ? config.mediaURL
        : config.mediaURL + '/'
    };
  }
};
